const KEY = 'askIfReturnConversation';

export function setAskIfReturnConversation(id?: number) {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(KEY, id && Number.isFinite(id) && id > 0 ? String(id) : 'new');
}

export function peekAskIfReturnConversation(): number | 'new' | null {
  if (typeof sessionStorage === 'undefined') return null;
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  if (raw === 'new') return 'new';
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function askIfReturnPath(id: number | 'new'): string {
  return id === 'new' ? '/jarvis' : `/jarvis?conversation=${id}`;
}

export function clearAskIfReturnConversation() {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(KEY);
}
